import { StatTableColumn } from "components/StatsTable/StatTableColumn";
import {
  BEST_HEADER,
  BEST_TITLE,
  DNF_HEADER,
  DNF_TITLE,
  MEDIAN_HEADER,
  MEDIAN_TITLE,
} from "stats/TimeStats";
import { SharedTeamTrackStats } from "stats/Track/Team/SharedTeamTrackStats";
import {
  BANS_HEADER,
  BANS_TITLE,
  PICKS_HEADER,
  PICKS_TITLE,
} from "stats/TrackPickStats";

export const sharedTrackTeamStatTableColumns: StatTableColumn<SharedTeamTrackStats>[] =
  [
    {
      type: "OrgLogoName",
      sortable: true,
      nameGetter: (arg) => arg.displayName,
      orgIdGetter: (arg) => arg.orgId,
    },
    {
      type: "Time",
      header: BEST_HEADER,
      title: BEST_TITLE,
      sortable: true,
      timeGetter: (arg) => arg.bestTime,
      // todo - removed for selector not rerender purposes, to be re-added
      // driverIdsGetter: !!showDriverBestName
      //   ? (arg) => arg.bestTime.driverIds
      //   : undefined,
    },
    {
      type: "Time",
      header: MEDIAN_HEADER,
      title: MEDIAN_TITLE,
      sortable: true,
      timeGetter: (arg) => arg.medianTime,
    },
    {
      type: "Percent",
      header: DNF_HEADER,
      title: DNF_TITLE,
      sortable: true,
      rateGetter: (arg) => arg.dnfRate,
      subTextGetter: (arg) => arg.dnfBreakdown,
      fractionDigits: 1,
      sortDescFirst: true,
    },
    {
      type: "Percent",
      header: PICKS_HEADER,
      title: PICKS_TITLE,
      sortable: true,
      rateGetter: (arg) => arg.pickRate,
      subTextGetter: (arg) => arg.pickBreakdown,
      fractionDigits: 0,
      sortDescFirst: true,
    },
    {
      type: "Percent",
      header: BANS_HEADER,
      title: BANS_TITLE,
      sortable: true,
      rateGetter: (arg) => arg.banRate,
      subTextGetter: (arg) => arg.banBreakdown,
      fractionDigits: 0,
      sortDescFirst: true,
    },
  ];
